<div class="input-wrapper">
  <!-- All added claims -->
  <div *ngIf="!sharedConfig.addingClaim">
    <!-- <div class="header" *ngIf="!summary">
      <h2 class="question-heading">{{ question.sub_heading }}</h2>
    </div> -->
    <div class="top-button">
      <ion-button mode="ios" (click)="newClaim()" class="secondary-button">Add +</ion-button>
    </div>
    @for (item of this.question.underwriting_answers[0].object_answer; track $index; let i = $index) {
      <ion-item class="ion-item-claim" mode="md"  lines="none">
        <ion-text>
          <ion-label>{{ item.reason ? item.reason : item.description }}</ion-label>
          @if (item.date_full) {
            <div>
              <small>{{ setDateFormat(item?.date_full) }}</small>
            </div>
          }

          @if (item?.sum_insured) {
            <div>
              <small>Sum insured value - R {{ item.sum_insured }}</small>
            </div>
          }
        </ion-text>
        <ion-icon (click)="deleteItem(i)" class="swiper-icon" slot="end" src="assets/icon/genetic-icons/trash.svg">
        </ion-icon>
      </ion-item>
    }
  </div>
</div>
<!-- Adding Claim -->
  <div *ngIf="sharedConfig.addingClaim">
    <!-- <div class="header">
      <h2 class="question-heading" *ngIf="showHeading">{{ question.secondPageQuestion }}</h2> >>>>> this line here is commented out because secondPageQuestion is just an empty string in firebase, if we need to add a heading here is the template
    </div> -->
    @for (definition of question.underwriting_answers[0].object_definitions; track $index; let defIndex = $index) {
      @if (definition.type === 'DateStr') {
        <ion-item mode="ios" (click)="showCalender()">
          <ion-input label="Select date" labelPlacement="stacked" type="text" readonly="true" placeholder="YYYY-MM" [(ngModel)]="dateFormate"></ion-input>
          <ion-icon name="calendar-outline" slot="end" class="calendar-icon"></ion-icon>
        </ion-item>
      }
      @if (definition.options.length > 0) {
        <ion-item mode="ios" (click)="showSelect(defIndex)">
          <ion-label position="stacked">{{definition.label}}</ion-label>
          <ion-input readonly="true" [(ngModel)]="selectedClaim[definition.field]"></ion-input>
        </ion-item>

        @if (showOptions === defIndex) {
          <ion-radio-group value="{{ claimReason }}">
            @for (option of definition.options; track $index) {
              <ion-item
                class="ion-item-sub"
                mode="md"
                lines="none"
                (click)="selectReason(option, definition.field)"
                [ngClass]="{ active: option == selectedClaim[definition.field] }"
              >
                <ion-text>{{ option }}</ion-text>
                <ion-icon
                  class="checked icon-fill-primary"
                  [ngClass]="{ selected: option == selectedClaim[definition.field] }"
                  src="assets/icon/genetic-icons/tick-primary.svg"
                  slot="end"
                ></ion-icon>
              </ion-item>
            }
          </ion-radio-group>
        }
      }

      @if (definition.type === 'int') {
        <ion-item mode="ios">
          <ion-input label="{{definition?.label}}" labelPlacement="stacked" type="number" (input)="answerValue($event, definition.field, definition.type)"></ion-input>
        </ion-item>
      }
    }
  </div>

  <div class="button-row" [ngClass]="{ 'mb-8': sharedConfig.hideHeaderWhenAddedClaimType, 'edit-row': editClaim }">
    <ion-button mode="ios" *ngIf="sharedConfig.addingClaim && editClaim" style="margin-bottom: 8px" class="secondary-button" (click)="showRemoveClaim()"
      >Remove claim</ion-button
    >
    <ion-button
      mode="ios"
      *ngIf="sharedConfig.addingClaim"
      
      (click)="addEditClaim()"
      class="primary-button"
      >Done</ion-button
    >
    <ion-button mode="ios" *ngIf="!readOnly && !sharedConfig.addingClaim && showHeading" (click)="nextQuestion()" class="primary-button"
      >Next</ion-button
    >
    @if (sharedConfig.addingClaim ) {
      <ion-button mode="ios" (click)="cancel()" class="secondary-button"
        >Cancel</ion-button>
    }
  </div>

<!-- Remove claim popup -->
<div class="backdrop" *ngIf="showRemoveClaimPopup"></div>
<div class="popup-standard limit-width-on-desktop-float" *ngIf="showRemoveClaimPopup">
  <div class="text-center">
    <h2 class="h2-bold">Are you sure you want to remove this claim?</h2>
  </div>
  <div class="buttons-wrapper">
    <ion-button mode="ios" class="primary-button" (click)="removeClaim()">Remove claim </ion-button>
    <ion-button mode="ios" class="secondary-button" (click)="cancelRemove()">Cancel</ion-button>
  </div>
</div>

<popup-calendar  *ngIf="sharedConfig.showCalendarPopup" [heading]="'Select date:'" (setDate)="pickDate($event)" [dateFormat]="'month-year'" [maxDate]="maxDate" [minDate]="minDate" [ngModal]="selectedClaim.date_full"></popup-calendar>

